import { useParams } from 'react-router-dom'
import useSWR from 'swr'

import { getReportStats } from '~/api'

export enum ReportPVType {
  Comparison = 'Comparison Report Detail Page View',
  Benchmark = 'Benchmark Report Detail Page View',
  SystemCheck = 'System Check Report Detail Page View'
  // Infra = 'Infra Report Detail Page View'
}

export const useReportPV = (reportType: ReportPVType, hash: string = '') => {
  const { orgId, cid } = useParams<'orgId' | 'cid'>()
  const { data } = useSWR(
    `/orgs/${orgId}/clusters/${cid}/pv/${reportType}`,
    () => getReportStats(reportType, hash ? `#${hash}` : '')
  )
  return { pv: data?.data?.count }
}
